import {
    Divider,
    Theme,
    createStyles,
    makeStyles,
} from '@material-ui/core';
import {
    ArrayField,
    Datagrid,
    DateField,
    ReferenceField,
    SelectField,
    Show,
    ShowProps,
    TextField,
} from 'react-admin';
import {
    GridShowLayout,
    RaGrid,
} from 'ra-compact-ui';
import {
    dayOrNightChoices,
} from '../types';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        headerField: {
        },
        contentField: {
            fontSize: '1.1rem',
        },
        footerField: {
            display: 'inline-block',
            marginRight: theme.spacing(2),
        },
        divider: {
            margin: theme.spacing(2, 0, 2),
        },
    }),
);

export const WorkReportTemplateShow = (props: ShowProps) => {
    const classes = useStyles();
    return (
        <Show {...props}>
            <GridShowLayout>
                <TextField source="id" label="ID" />
                <Divider className={classes.divider} />
                <RaGrid container spacing={2}>
                    <RaGrid item xs={12}>
                        <TextField source="name" label="名前" className={classes.contentField} />
                    </RaGrid>
                    <RaGrid item xs={2}>
                        <SelectField source="dayOrNight" label="昼夜" choices={dayOrNightChoices} fullWidth className={classes.contentField} />
                    </RaGrid>
                    <RaGrid item xs={12}>
                        <ArrayField source="details" label="明細" fullWidth>
                            <Datagrid>
                                <ReferenceField source="contractorCategoryId" label="業種" reference="contractorCategories" link="show" fullWidth>
                                    <TextField source="name" fullWidth className={classes.contentField} />
                                </ReferenceField>
                                <ReferenceField source="contractorId" label="発注先" reference="contractors" link="show" fullWidth>
                                    <TextField source="name" fullWidth className={classes.contentField} />
                                </ReferenceField>
                                <ReferenceField source="workUnitId" label="項目名" reference="workUnits" link="show" fullWidth>
                                    <TextField source="name" fullWidth className={classes.contentField} />
                                </ReferenceField>
                            </Datagrid>
                        </ArrayField>
                    </RaGrid>
                </RaGrid>
                <Divider className={classes.divider} />
                <DateField source="createdAt" label="作成日時" showTime className={classes.footerField} />
                <ReferenceField source="createdBy" label="作成者" reference="users" link="show" className={classes.footerField}>
                    <TextField source="name" />
                </ReferenceField>
                <DateField source="updatedAt" label="更新日時" showTime className={classes.footerField} />
                <ReferenceField source="updatedBy" label="更新者" reference="users" link="show" className={classes.footerField}>
                    <TextField source="name" />
                </ReferenceField>
            </GridShowLayout>
        </Show>
    );
};
